const defaultstate = { status: false, uid: '', name: '' }

export default function (state = defaultstate, action) {
    switch (action.type) {
        case 'FETCH_SUCCESS':
            return {
                ...state.state,
                status: action.payload.status,
                uid: action.payload.uid,
                name: action.payload.name
            };
        default:
            return state
            
    }
}